import React, { Component } from 'react';
import withAuth from "../../withAuth";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PortalLayout from "../../layout/portal-layout";
import { Button, Card, Form, Modal, Spinner} from "react-bootstrap";
import { Menu, Segment } from "semantic-ui-react";
import {fetchLinesOfEducation, fetchVolunteerApplication, postVolunteerApplicationDecision} from "../../services/api";

import VolunteerApplicationPersonalDetails from "./volunteer-application-personal-details";
import {withTranslation} from "react-i18next";
import VolunteerApplicationEducation from "./volunteer-application-education";
import VolunteerApplicationDescriptions from "./volunteer-application-descriptions";
import VolunteerApplicationDocuments from "./volunteer-application-documents";
import {Formik} from "formik";
import {volunteerApplicationApprovalFormSchema} from "./validation-rules";

const DECISION_ACCEPTED = "ACCEPTED";
const DECISION_REJECTED = "REJECTED";

class VolunteerApplicationApproval extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeItem : "tab-personal-details",
      application: undefined,
      linesOfEducation: undefined,
      mediaFiles: undefined,
      isLoading: true,

      descriptionCheck: false,

      openAcceptApplicationModal: false,
      "approval-feedback-provided": false,

      openRejectApplicationModal: false
    };
  }

  handleItemClick = (e, { id }) => {
    this.setState({
      ...this.state,
      activeItem: id
    });
  }

  componentDidMount() {
    Promise.all([
      fetchLinesOfEducation(),
      fetchVolunteerApplication(this.props.match.params.applicationId)
    ])
      .then(([res1, res2]) => {
        return Promise.all([res1.json(), res2.json()])
      })
      .then(([linesOfEducation, applicationResponse]) => {
        this.setState({
          ...this.state,
          linesOfEducation: linesOfEducation,
          application: applicationResponse.application,
          mediaFiles: applicationResponse.mediaFiles,
          isLoading: false
        })
      })
      .catch((error) => (
        this.setState({
          ...this.state,
          application: undefined,
          linesOfEducation: undefined,
          mediaFiles: undefined,
          isLoading: false
        })
      ));
  }

  onFormSubmit({decision}) {
    const t = this.props.t;

    let data = {
      applicationId: this.state.application.applicationId,
      decision: decision
    }

    if (decision === DECISION_ACCEPTED) {
      data = {
        ...data,
        lineOfEducationId: this.formik.values.lineOfEducationId,
        selfDescription: this.formik.values.selfDescription,
        careerReasons: this.formik.values.careerReasons,
        joiningReasons: this.formik.values.joiningReasons,

        reviewComments: this.state['approval-feedback-provided'] ? this.state['approval-feedback'] : undefined
      }
    } else if (decision === DECISION_REJECTED) {
      data = {
        ...data,
        reviewComments: this.state['reject-reason']
      }
    }

    postVolunteerApplicationDecision(data)
      .then((response) => {
        if (!response.ok) {
          // Handle error
          this.setState({
            ...this.state,
            error : t('volunteer-application.error.network.server-request-failed', {"status": response.status})
          });
        } else {
          // Display toast informing that decision was communicated
          // Move view to list of applications
          this.props.history.push('/volunteer-applications')
        }
      })
      .catch(e => {
        let errorReason;
        if (e.response === undefined) {
          errorReason = "Connection failed";
        } else {
          errorReason = e.response;
        }

        this.setState({
          ...this.state,
          error: t('volunteer-application.error.network.server-connection-failed', {"reason": errorReason})
        });
      })
  }

  handleChange = (e) => {
    let value;
    if (e.target.checked !== undefined) {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }

    this.setState({
      ...this.state,
      [e.target.id]: value
    })
  }

  onHandleApprove = () => {

    this.formik.validateForm()
      .then((errors) => {
        if (this.formik.isValid) {
          this.setState({
            ...this.state,

            openAcceptApplicationModal: true
          })
          return;
        }

        if (errors.lineOfEducationId !== undefined) {
          this.setState({
            ...this.state,
            activeItem: 'tab-education'
          })
          return;
        }

        if (errors.selfDescription !== undefined ||
            errors.careerReasons !== undefined ||
            errors.joiningReasons !== undefined) {
          this.setState({
            ...this.state,
            activeItem: 'tab-descriptions'
          })
        }
      })
  }

  onHandleReject = () => {
    this.setState({
      ...this.state,

      openRejectApplicationModal: true
    })
  }

  render() {
    const t = this.props.t;

    return (
      <PortalLayout>
        <div className="container-fluid volunteer-application-container" style={{flex: '1 1 auto', paddingBottom: "64px"}}>

          <h1 className="h3 mb-4 text-gray-800">Αίτηση Εθελοντή</h1>

          {
            this.state.isLoading &&
            <Spinner animation="border" role="status"/>
          }

          {
            !this.state.isLoading &&
            this.state.application === undefined &&
            <div id={'error-view-access-denied'} className="ui negative message">
              <div className="header">
                Δυστυχώς δε μπορούμε να φορτώσουμε την αίτηση.
              </div>
              <p>Ελέγξτε τα δικαιώματα χρήσης σας και τη σύνδεση με το διακομιστή</p>
            </div>
          }

          {
            !this.state.isLoading &&
            this.state.application !== undefined &&
            <Card id={'volunteer-application-approval'}>
              <Card.Header>{this.state.application.firstName + ' ' + this.state.application.lastName} ({this.state.application.email})</Card.Header>
              <Card.Body>
                <Menu pointing>
                  <Menu.Item id={"tab-personal-details"}
                             name={t('volunteer-application.menu.personal-details')}
                             active={this.state.activeItem === 'tab-personal-details'}
                             onClick={this.handleItemClick}/>
                  <Menu.Item id={"tab-education"}
                             name={t('volunteer-application.menu.education')}
                             active={this.state.activeItem === 'tab-education'}
                             onClick={this.handleItemClick}/>
                  <Menu.Item id={"tab-descriptions"}
                             name={t('volunteer-application.menu.descriptions')}
                             active={this.state.activeItem === 'tab-descriptions'}
                             onClick={this.handleItemClick}/>
                  <Menu.Item id={"tab-documents"}
                             name={t('volunteer-application.menu.documents')}
                             active={this.state.activeItem === 'tab-documents'}
                             onClick={this.handleItemClick}/>
                </Menu>
                <Segment>
                  <Formik innerRef={node => {this.formik = node}}
                          validationSchema={volunteerApplicationApprovalFormSchema}
                          initialValues={{
                            firstName: this.state.application.firstName,
                            lastName: this.state.application.lastName,
                            city: this.state.application.city,
                            country: this.state.application.country,
                            email: this.state.application.email,
                            canPresentOnline: this.state.application.canPresentOnline,
                            canPresentInPerson: this.state.application.canPresentInPerson,
                            lineOfEducationId: this.state.application.lineOfEducationId,
                            otherLineOfEducation: this.state.application.otherLineOfEducation,
                            educationLevel: this.state.application.educationLevel,
                            employer: this.state.application.employer,
                            selfDescription: this.state.application.selfDescription,
                            careerReasons: this.state.application.careerReasons,
                            joiningReasons: this.state.application.joiningReasons,
                          }}>
                    {( {values, errors, touched,
                         handleChange, handleBlur, handleSubmit,
                         isSubmitting, setFieldValue }) => (
                      <Form>
                        {
                          this.state.activeItem === 'tab-personal-details' &&
                          <VolunteerApplicationPersonalDetails values={values} touched={touched} errors={errors}
                                                               handleChange={handleChange} handleBlur={handleBlur}
                                                               setFieldValue={setFieldValue}/>
                        }
                        {
                          this.state.activeItem === 'tab-education' &&
                          <VolunteerApplicationEducation values={values} touched={touched} errors={errors}
                                                         handleChange={handleChange} handleBlur={handleBlur}
                                                         setFieldValue={setFieldValue}
                                                         linesOfEducation={this.state.linesOfEducation}/>
                        }
                        {
                          this.state.activeItem === 'tab-descriptions' &&
                          <VolunteerApplicationDescriptions values={values} touched={touched} errors={errors}
                                                            handleChange={handleChange} handleBlur={handleBlur}
                                                            setFieldValue={setFieldValue}/>
                        }
                        {
                          this.state.activeItem === 'tab-documents' &&
                          <VolunteerApplicationDocuments application={this.state.application}
                                                         mediaFiles={this.state.mediaFiles}/>
                        }
                      </Form>
                    )}
                  </Formik>
                </Segment>
              </Card.Body>
              <Card.Footer>
                <div className={'row'}>
                  <div className={'col'}>
                    <Button id='btn-reject' variant={'danger'} onClick={this.onHandleReject}>{t('common:buttons.reject')}</Button>
                  </div>
                  <div className={'col text-right'}>
                    <Button id='btn-approve' variant={'success'} onClick={this.onHandleApprove}>{t('common:buttons.accept')}</Button>
                  </div>
                </div>
              </Card.Footer>
            </Card>
          }

          <Modal id='volunteer-application-reconfirm-approval' show={this.state.openAcceptApplicationModal}
                 onHide={() => this.setState({...this.state, openAcceptApplicationModal: false})}
                 centered>
            <Modal.Header closeButton>
              <Modal.Title>{t('volunteer-application.notes.confirmation-approval.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{t('volunteer-application.notes.confirmation-approval.prompt')}</p>
              <ul>
                <li>{t('volunteer-application.notes.confirmation-approval.check-descriptions')}</li>
                <li>{t('volunteer-application.notes.confirmation-approval.check-photos')}</li>
              </ul>
              <p>{t('volunteer-application.notes.confirmation-approval.next-steps')}</p>
              <Form>
                <Form.Check id={"approval-feedback-provided"}
                            checked={this.state["approval-feedback-provided"]}
                            label={t('volunteer-application.notes.confirmation-approval.provide-feedback')}
                            onChange={this.handleChange}/>
                <Form.Control as={'textarea'} id={'approval-feedback'}
                              value={this.state['approval-feedback']}
                              hidden={!this.state['approval-feedback-provided']}
                              placeholder={t('volunteer-application.notes.confirmation-approval.feedback-placeholder')}
                              onChange={this.handleChange}/>
                <Form.Text className={'text-muted'}>{t('volunteer-application.notes.confirmation-approval.feedback-note')}</Form.Text>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              {
                this.state.error !== undefined &&
                <div style={{color: 'red'}}>{this.state.error}</div>
              }
              <Button id='btn-reconfirm-retract'
                      variant={'link'}
                      onClick={() => this.setState({...this.state, openAcceptApplicationModal: false})}>{t('common:buttons.close')}</Button>
              <Button id='btn-reconfirm-confirm'
                      variant={'success'}
                      onClick={() => this.onFormSubmit({decision: DECISION_ACCEPTED})}>{t('common:buttons.confirm')}</Button>
            </Modal.Footer>
          </Modal>

          <Modal id='volunteer-application-reconfirm-rejection' show={this.state.openRejectApplicationModal}
                 onHide={() => this.setState({...this.state, openRejectApplicationModal: false})}
                 centered>
            <Modal.Header closeButton>
              <Modal.Title>{t('volunteer-application.notes.confirmation-rejection.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>{t('volunteer-application.notes.confirmation-rejection.prompt')}</p>
              <ul>
                <li>{t('volunteer-application.notes.confirmation-rejection.check-descriptions')}</li>
                <li>{t('volunteer-application.notes.confirmation-rejection.check-photos')}</li>
              </ul>
              <p>{t('volunteer-application.notes.confirmation-rejection.next-steps')}</p>
              <Form>
                <Form.Label>{t('volunteer-application.notes.confirmation-rejection.rejection-reason')}</Form.Label>
                <Form.Control as={'textarea'} id={'reject-reason'}
                              value={this.state["reject-reason"]}
                              placeholder={t('volunteer-application.notes.confirmation-rejection.rejection-reason-placeholder')}
                              onChange={this.handleChange}/>
                <Form.Text className={'text-muted'}>{t('volunteer-application.notes.confirmation-rejection.rejection-reason-note')}</Form.Text>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              {
                this.state.error !== undefined &&
                <div style={{color: 'red'}}>{this.state.error}</div>
              }
              <Button id='btn-reconfirm-retract'
                      variant={'link'}
                      onClick={() => this.setState({...this.state, openRejectApplicationModal: false})}>{t('common:buttons.close')}</Button>
              <Button id='btn-reconfirm-confirm'
                      variant={'danger'}
                      onClick={() => this.onFormSubmit({decision: DECISION_REJECTED})}>{t('common:buttons.confirm')}</Button>
            </Modal.Footer>
          </Modal>
        </div>
      </PortalLayout>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  profile: state.profile
});

export default withAuth(withRouter(connect(mapStateToProps)(withTranslation(['volunteer-application', 'common'])(VolunteerApplicationApproval))))
{/*
What's the store that you would like to max out your credit card at?
What's your favorite cartoon character?
What's the movie that describes the story of your life?
What was your favorite toy while growing up?
Which instrument do or did you play?
What is the nerdiest thing that you have done in your spare time?
What is your favorite serial?
What is anything that you have ever regretted (or re-gifted)?
What is your strangest talent that you've got?
Did you have a childhood nickname?
Do you have any strange phobias?
What color socks are you wearing? Do they have any holes?
Two things that you have in your bucket list?
What's your favorite food?
If you had a superpower what would you like that to be?
What car are you driving?
Have you ever accepted a dare that you regretted?

*/}